// note this input component accepts formik prop

import React from 'react';
import PropTypes from 'prop-types';

import {
  STRING_FIELD_EXPERIENCE_COMPANY,
} from '../labels';

import FormikLabeledField from './FormikLabeledField';

import formikPropTypes from './formikPropTypes';

export function EmployerField({
  name, formikProps,
}) {
  return (
    <FormikLabeledField
      name={name}
      formikProps={formikProps}
      label={STRING_FIELD_EXPERIENCE_COMPANY}
      placeholder={STRING_FIELD_EXPERIENCE_COMPANY}
    />
  );
}

EmployerField.propTypes = {
  name: PropTypes.string.isRequired,
  formikProps: formikPropTypes.isRequired,
};

export default EmployerField;
